import React, { useEffect, useMemo, useState,useContext } from 'react';

import { setToken } from '../../../../service/mftc-api';
import '../../../../App.css';
import { Link } from 'react-router-dom';
import { MfctContext } from "../../../../context";
import * as fa from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function NotFound() {



  return (
    <div className="App"> 
      <div className='flex flex-row'> 
      <Link to="/"> <FontAwesomeIcon  icon={fa.faArrowLeft} className='mx-4'></FontAwesomeIcon> </Link> 
       
       404 NOT FOUND</div>
      
        <p>
     </p>
      <div className='flex flex-col text-xs'>

     
     </div>

        
    
   
    </div>
  );
}

export default NotFound;
